/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetBillingDetails200ResponseTax
 */
export interface GetBillingDetails200ResponseTax {
    /**
     * 
     * @type {string}
     * @memberof GetBillingDetails200ResponseTax
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof GetBillingDetails200ResponseTax
     */
    value: number;
}

/**
 * Check if a given object implements the GetBillingDetails200ResponseTax interface.
 */
export function instanceOfGetBillingDetails200ResponseTax(value: object): value is GetBillingDetails200ResponseTax {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function GetBillingDetails200ResponseTaxFromJSON(json: any): GetBillingDetails200ResponseTax {
    return GetBillingDetails200ResponseTaxFromJSONTyped(json, false);
}

export function GetBillingDetails200ResponseTaxFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBillingDetails200ResponseTax {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
    };
}

export function GetBillingDetails200ResponseTaxToJSON(json: any): GetBillingDetails200ResponseTax {
    return GetBillingDetails200ResponseTaxToJSONTyped(json, false);
}

export function GetBillingDetails200ResponseTaxToJSONTyped(value?: GetBillingDetails200ResponseTax | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'value': value['value'],
    };
}

